module.exports = __webpack_public_path__ + "static/media/no_photo_150px.b154fbe1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no_photo/no_photo_150px.png
// module id = 1598
// module chunks = 0